<template>
  <div v-if="hideTooltip" :class="getIconType" />
  <div
    v-else
    v-tippy="
      tooltip.length > 0 || iconName
        ? {
            theme: 'WSM',
            content:
              tooltip.length > 0
                ? translateIconName(tooltip)
                : translateIconName(iconName.toLowerCase()),
            placement: 'top',
          }
        : ''
    "
    :class="getIconType"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import {
  CHAMPIONSHIP_POINTS,
  EVENT_POINTS,
  RANKING_POINTS,
  TOURNAMENT_TITLES,
  TROPHY_GOLD,
  WON_MATCHES,
  TOURNAMENT_POINTS,
  MULLIGANS,
  TOURNAMENT_POINTS_DISCIPLINE_2,
} from '@/globalVariables'
import { defineComponent } from 'vue'
import { useEventInfoStore } from '@/store/pinia/events/eventInfoStore'
import { mapState } from 'pinia'
import { EventType } from '@/interfaces/events/EventInfo'
import { translateIconName } from '@/helpers/translateIconName'

export default defineComponent({
  name: 'AppMainIcon',
  props: {
    iconName: {
      type: String,
      required: true,
      validator(value: string): boolean {
        return [
          'training_points',
          'energy',
          'money',
          'gems',
          'starts',
          'UNIVERSAL_TRAINING_POINTS',
          'universal_training_points',
          'prestige',
          'research_points',
          'gallery_pieces',
          'benefits',
          'ranking_points',
          RANKING_POINTS,
          'experience',
          'EXPERIENCE',
          'stars',
          'wild_card',
          'energy_drink',
          'grand_prize',
          'gp-basic',
          'gp-bronze',
          'gp-silver',
          'gp-gold',
          'gp-diamond',
          'powerboost-attribute_bronze',
          'powerboost-attribute_silver',
          'powerboost-attribute_gold',
          'personal-cash_bronze',
          'personal-cash_silver',
          'personal-cash_gold',
          'protraining-training_points_bronze',
          'protraining-training_points_silver',
          'protraining-training_points_gold',
          'benefit-1',
          'benefit-2',
          'benefit-3',
          'benefit-4',
          'benefit-5',
          'benefit-6',
          'benefit-7',
          'benefit-8',
          'benefit-9',
          'prestige',
          'trophy-bronze',
          'trophy-silver',
          'trophy-gold',
          'star-full',
          'career-gold',
          'masters_playoff_points',
          EVENT_POINTS,
          CHAMPIONSHIP_POINTS,
          'gallery_piece',
          WON_MATCHES,
          'won_matches',
          'first-place',
          TOURNAMENT_TITLES,
          'helmet',
          'target',
          'event_points_multiplier',
          TROPHY_GOLD,
          'medals',
          'multiplier_5',
          'piggy_bank_universal_training_points',
          'piggy_bank_gems',
          'piggy_bank_money',
          TOURNAMENT_POINTS,
          MULLIGANS,
          'gunpowder',
          'fortune-basket-token',
          'fortune-festival-basket-token',
          'double-reward',
          'triple-reward',
          'refresh',
          'league_points',
          'fortune_basket_shuffle',
          'fortune_basket_double',
          'fortune_basket_triple',
          'open-in-new-tab',
          TOURNAMENT_POINTS_DISCIPLINE_2,
          'gallery-pack-regular',
          'gallery_pack_regular',
          'gallery-pack-premium',
          'gallery_pack_premium',
          'gallery-pack-jumbo',
          'gallery_pack_jumbo',
          'puzzle-common',
          'puzzle-rare',
          'puzzle-epic',
          'gallery_pieces_common',
          'gallery_pieces_rare',
          'gallery_pieces_epic',
          'gallery_picture_301',
          'gallery_picture_306',
          'gallery_picture_307',
          'gallery_picture_308',
          'gallery_picture_309',
          'gallery_picture_310',
          'gallery_picture_311',
        ].includes(value)
      },
    },
    iconSize: {
      type: Number,
      required: true,
      validator(value: number): boolean {
        return [24, 32, 38, 48, 52, 56, 72, 80, 90, 104, 120, 152, 184, 360].includes(value)
      },
    },
    tooltip: {
      type: String,
      default: '',
    },
    hideTooltip: {
      type: Boolean,
      default: false,
    },
    gpRarity: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(useEventInfoStore, {
      eventType: 'getEventType',
    }),
    getIconType(): string {
      if (
        this.eventType === EventType.Fortune &&
        (this.iconName === 'fortune_basket_token' || this.iconName === 'fortune-basket-token')
      ) {
        return `icon-fortune-festival-basket-token-${this.iconSize}`
      }

      return (
        'icon-' +
        (typeof this.iconName === 'string' ? this.iconName.toLowerCase() : '') +
        '-' +
        (this.gpRarity ? this.gpRarity + '-' : '') +
        this.iconSize
      )
    },
  },
  methods: {
    translateIconName,
  },
})
</script>

<style lang="scss">
@import '@/assets/styles/components/icons/main-icons.scss';
@import '@/assets/styles/components/icons/benefits-icons.scss';

// Ked zacneme pouzivat mode: 'jit', tak toto moze ist doprec.
// https://v2.tailwindcss.com/docs/just-in-time-mode
.\!mx-0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
